import React from 'react';
import { Select, SelectProps } from 'antd';

import { projectApi } from '../../services/api';
import { SimpleProject } from '../../types';

export interface ProjectSelectProps
  extends Omit<SelectProps<string>, 'options'> {
  projects?: SimpleProject[];
}

export const ProjectSelect: React.FC<ProjectSelectProps> = ({
  projects: initialProjects,
  ...props
}) => {
  const [projects, setProjects] = React.useState<
    { label: string; value: string }[]
  >([]);

  React.useEffect(() => {
    if (initialProjects) {
      setProjects(
        initialProjects.map((item) => ({ label: item.name, value: item.id })),
      );

      return;
    }

    (async () => {
      const resp = await projectApi.getAll();

      setProjects(resp.map((item) => ({ label: item.name, value: item.id })));
    })();
  }, [initialProjects]);

  return (
    <Select showSearch optionFilterProp="label" {...props} options={projects} />
  );
};
